import React from 'react';
import { Container } from './ui/Container';
export function MechanismSection() {
  return <section className="py-16 bg-white overflow-hidden" data-id="element-253">
      <Container data-id="element-254">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-255">
          <div className="order-2 lg:order-1" data-id="element-256">
            <img src="https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png" alt="SnoreStop Mechanism" className="w-full max-w-md mx-auto drop-shadow-2xl" data-id="element-257" />
          </div>

          <div className="order-1 lg:order-2 space-y-8" data-id="element-258">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-259">How It Works</h2>

            <div className="space-y-6" data-id="element-260">
              <div className="flex gap-4" data-id="element-261">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-900 text-white flex items-center justify-center font-bold text-lg" data-id="element-262">
                  01
                </div>
                <div data-id="element-263">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-264">
                    What Activates It
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-265">
                    <span className="font-semibold" data-id="element-266">
                      Gently holds your jaw forward.
                    </span>{' '}
                    Keeps your airway open while you sleep, so air flows freely
                    instead of vibrating your throat.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-267">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-900 text-white flex items-center justify-center font-bold text-lg" data-id="element-268">
                  02
                </div>
                <div data-id="element-269">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-270">
                    What It Mobilizes
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-271">
                    <span className="font-semibold" data-id="element-272">
                      Stabilizes your breathing all night.
                    </span>{' '}
                    Reduces the collapsing of soft tissues that cause loud
                    snoring sounds.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-273">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-900 text-white flex items-center justify-center font-bold text-lg" data-id="element-274">
                  03
                </div>
                <div data-id="element-275">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-276">
                    What It Balances
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-277">
                    <span className="font-semibold" data-id="element-278">
                      Restores silent breathing patterns.
                    </span>{' '}
                    So you and your partner finally get deep, uninterrupted
                    sleep again.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}